import { render, staticRenderFns } from "./QLVeicoli.vue?vue&type=template&id=2254517c&scoped=true&"
import script from "./QLVeicoli.vue?vue&type=script&lang=js&"
export * from "./QLVeicoli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254517c",
  null
  
)

export default component.exports